import _ from '../../utils/underscore';
import { FP_VOUCHER_TYPES } from './free_play_consts';
import Logger from '../../../src/utils/logger';


export interface IFreePlayVoucher {
    ID: string;
    ExpirationDate: Date;
    CurrentBalance: number;
    Winnings: number;
    FreePlayTypeId: FP_VOUCHER_TYPES;
    OriginAmount: number;
    SpinBetAmount: number;
    GameTypeIDList: number[];
    CompanyID?: number;
    PendingDeletion?: boolean;
}

// firebase sends partial information (only fields that were changed)
// so that's why IFreePlayVoucherDelta exists
// it must contain ID anyway and first received update from firebase normally contains all fields
export type IFreePlayVoucherDelta = {
    ID: string;
} & Partial<IFreePlayVoucher>;

export class FreePlayVoucher {

    constructor(voucher: IFreePlayVoucher) {
        this._voucher = voucher;
    }

    private _voucher: IFreePlayVoucher;

    private _logger = new Logger('FreePlayVoucher');

    isThirdPartyVoucher(): boolean {
        return this._voucher && !_.isNullOrUndefined(this._voucher.CompanyID);
    }

    isValid(checkExpirationDate: boolean) {
        if (!this._voucher) {
            this._logger.warn(`Invalid voucher object given`);
            return false;
        }
        if (!this._voucher.ID) {
            this._logger.warn(`Voucher ID ${this._voucher.ID} is invalid`);
            return false;
        }

        if (checkExpirationDate) {
            if (!this._voucher.ExpirationDate) {
                this._logger.warn(`Expiration date does not exist. Voucher ${this._voucher.ID}`);
                return false;
            }
            if (!(this._voucher.ExpirationDate instanceof Date)) {
                this._logger.warn(`Expiration date is not a Date instance. Voucher ${this._voucher.ID}`);
                return false;
            }
            if (!_.isNumber(this._voucher.ExpirationDate.getTime()))
            {
                this._logger.warn(`Expiration date is invalid. Voucher ${this._voucher.ID}`);
                return false;
            }
        }

        return true;
    }

    static isThirdPartyVoucher(toCheck: IFreePlayVoucher): boolean {
        return new FreePlayVoucher(toCheck).isThirdPartyVoucher();
    }

    static isValid(toCheck: IFreePlayVoucher, checkExpirationDate: boolean) {
        return new FreePlayVoucher(toCheck).isValid(checkExpirationDate);
    }
}
